import { render, staticRenderFns } from "./tgo-form.vue?vue&type=template&id=77192332&scoped=true&"
import script from "./tgo-form.vue?vue&type=script&lang=js&"
export * from "./tgo-form.vue?vue&type=script&lang=js&"
import style0 from "./tgo-form.vue?vue&type=style&index=0&id=77192332&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77192332",
  null
  
)

export default component.exports